import { render, staticRenderFns } from "./Screencasts.vue?vue&type=template&id=0ada7e26&scoped=true&"
import script from "./Screencasts.vue?vue&type=script&lang=js&"
export * from "./Screencasts.vue?vue&type=script&lang=js&"
import style0 from "./Screencasts.vue?vue&type=style&index=0&id=0ada7e26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada7e26",
  null
  
)

export default component.exports